import { ProgressBar } from '@terminal/components/progress-bar/ProgressBar';
import { useTranslation } from 'react-i18next';

import styles from './SingleDocLoader.module.scss';

export const SingleDocLoader = () => {
  const { t } = useTranslation(['chat']);

  return (
    <div className={styles.singleDocLoaderRoot} data-testid="single-doc-loader">
      <ProgressBar
        className={styles.styledProgressBar}
        animationDuration={'2000ms'}
      />
      <span className={styles.label}>{t('chat:docIsLoading')}</span>
    </div>
  );
};
